"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.667 2.66667C12.667 2.48986 12.5968 2.32029 12.4717 2.19526C12.3467 2.07024 12.1771 2 12.0003 2C11.8235 2 11.6539 2.07024 11.5289 2.19526C11.4038 2.32029 11.3336 2.48986 11.3336 2.66667L11.3336 13.3333C11.3336 13.5101 11.4038 13.6797 11.5289 13.8047C11.6539 13.9298 11.8235 14 12.0003 14C12.1771 14 12.3467 13.9298 12.4717 13.8047C12.5968 13.6797 12.667 13.5101 12.667 13.3333L12.667 2.66667ZM8.00009 2C8.17691 2 8.34649 2.07024 8.47152 2.19526C8.59655 2.32029 8.66679 2.48986 8.66679 2.66667L8.66679 13.3333C8.66679 13.5101 8.59655 13.6797 8.47152 13.8047C8.34649 13.9298 8.17691 14 8.00009 14C7.82327 14 7.6537 13.9298 7.52867 13.8047C7.40364 13.6797 7.33339 13.5101 7.33339 13.3333L7.33339 2.66667C7.33339 2.48986 7.40364 2.32029 7.52867 2.19526C7.6537 2.07024 7.82327 2 8.00009 2ZM3.9999 2C4.17672 2 4.34629 2.07024 4.47132 2.19526C4.59635 2.32029 4.6666 2.48986 4.6666 2.66667L4.66659 13.3333C4.66659 13.5101 4.59635 13.6797 4.47132 13.8047C4.34629 13.9298 4.17672 14 3.9999 14C3.82308 14 3.6535 13.9298 3.52847 13.8047C3.40344 13.6797 3.3332 13.5101 3.3332 13.3333L3.3332 2.66667C3.3332 2.48986 3.40344 2.32029 3.52847 2.19526C3.6535 2.07024 3.82308 2 3.9999 2Z",
    fill: fill
  }));
};

exports["default"] = _default;